import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

interface SimpleFeatureChange<T> {
    key: string;
    previousValue: boolean;
    currentValue: boolean;
}

@Injectable()
export class FeatureService {
    private _featuresMap = new Map<string, boolean>();

    private _$changeDetection = new Subject<SimpleFeatureChange<any>>();

    public get changeDetection$(): Observable<SimpleFeatureChange<any>> {
        return this._$changeDetection.asObservable();
    }

    public has(featureName: string): boolean {
        return this._featuresMap.get(featureName) || false;
    }

    public setFeature(key: string, value: boolean): void {
        const _previousValue = this._featuresMap.get(key) || null;
        if (_previousValue !== value) {
            const _simpleChange = {
                key,
                previousValue: _previousValue,
                currentValue: value
            };
            this._$changeDetection.next(_simpleChange);
            this._featuresMap.set(key, value);
        }
    }

    public observeKey$<T>(key: string): Observable<SimpleFeatureChange<T>> {
        return this.changeDetection$.pipe(filter((change) => change.key === key));
    }
}
